export default __webpack_public_path__ + "static/media/mainImage2.5dd4634a.jpg";